import { RequestedUnavailability, Result, Unavailability } from "@models";
import requests from "./agent";

export const unavailabilityService = {
  getAll: async (request: RequestedUnavailability) => {
    const response = await requests.get<Result<Unavailability[]>>(
      "/api/Unavailability/GetUserUnavailability",
      { params: request }
    );
    return response.result;
  },
};
